module.exports = function(row) {
  this.dispatch('row-click', row);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/row-was-clicked.js